import type { ExpRateChartSnapshot } from '@/domain/types'
import type { AppLocale } from '@/i18n/locales'
import { expChartCopy } from '@/i18n/exp-chart'
import { widgetCopy, widgetText } from '@/i18n/widget-copy'

/** Keep the dashboard and default widget's empty chart states consistent. */
export function presentExpChartEmpty(status: string, model: ExpRateChartSnapshot | undefined, locale: AppLocale) {
  const recent = model?.recent
  const copy = widgetCopy(locale, {
    idle: 'Waiting to start', warming: 'Gathering samples', pending: 'Confirming', paused: 'Paused',
    unavailable: 'Waiting for a new EXP reading', ended: 'No chart data', ready: 'Waiting for a sample point',
  }, {
    idle: '等待开始记录', warming: '正在采样', pending: '正在确认', paused: '已暂停',
    unavailable: '等待新的经验读数', ended: '暂无曲线数据', ready: '等待采样点',
  })
  const state = status === 'ended' ? 'ended'
    : status === 'starting' ? 'pending'
      : status === 'idle' ? 'idle'
        : status === 'paused' ? 'paused'
          : status === 'interrupted' ? 'unavailable'
            : recent?.status === 'stale' ? 'unavailable' : recent?.status ?? 'unavailable'
  const continuous = recent?.continuousMs
  const windowMs = recent?.windowMs
  const samples = state === 'warming' && continuous != null && windowMs != null
    && Number.isFinite(continuous) && Number.isFinite(windowMs) && continuous >= 0 && windowMs > 0
    ? widgetText(locale, '{seconds}/{window}s', '{seconds}/{window} 秒', {
      seconds: Math.floor(Math.min(continuous, windowMs) / 1000), window: windowMs / 1000,
    }).replace('/', ' / ') : ''
  const rebuilding = state === 'warming' && model?.gaps.some(gap => gap.reason !== 'warming' && gap.from <= model.to)
  const label = rebuilding ? widgetCopy(locale, 'Rebuilding continuous samples', '恢复后重新采样') : copy[state]
  return { label, samples, description: `${expChartCopy[locale].title} · ${label}${samples ? ` · ${samples}` : ''}` }
}
